// Language mapping data
type LanguageKey = "Authorization" | "Card" | "Company" | "Checker" | "Report" | "MoneyTransfer" | "Roles" | "User";
type LanguageMap = Record<LanguageKey, { tr: string; en: string }>;

const languageMap: LanguageMap = {
  "Authorization": {
    "tr": "YETKİLENDİRME İŞLEMLERİ",
    "en": "Authorization"
  },
  "Card": {
    "tr": "KART İŞLEMLERİ",
    "en": "CARD"
  },
  "Company": {
    "tr": "FİRMA BİLGİLERİ",
    "en": "Company"
  },
  "Checker": {
    "tr": "ONAY/RED İŞLEMLERİ",
    "en": "approved/reject transaction"
  },
  "Report": {
    "tr": "İŞLEM RAPORLARI",
    "en": "Report"
  },
  "MoneyTransfer": {
    "tr": "PARA TRANSFER İŞLEMLERİ",
    "en": "MoneyTransfer"
  },
  "Roles": {
    "tr": "KULLANICI ROL YETKİLENDİRME",
    "en": "Roles"
  },
  "User": {
    "tr": "KULLANICI İŞLEMLERİ",
    "en": "User"
  }
};

export const translateText = (text: string, lang: 'tr' | 'en'): string => {
  const key = text as LanguageKey;
  const translation = languageMap[key];
  return translation ? translation[lang] : text;
};
